/**
 * 타겟 키워드·계정 묶음의 **이름 한 벌** — 추적 관리와 설정(타겟 키워드·알림)이 같은 말을 쓴다.
 *
 * 🔑 이름을 바꾸려면 이 값만 고친다(보류: 최종 이름 미정).
 * ⚠️ 이 이름이 들어간 문장의 조사(를·로·가)는 끝소리(모음)에 맞춰 적었다 — 받침 있는 이름으로 바꾸면 조사도 고친다.
 * ⚠️ 시딩 캠페인·외부 캠페인은 다른 기능이다 — 그 「캠페인」은 이 이름을 쓰지 않는다.
 */

/** 타겟 키워드·계정 묶음의 이름 */
export const SET = '세트';
